module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAnAAAAAQCAMAAAChprLiAAAAP1BMVEUAAAD1w6f0w6j2xKj2xKj1xKf2xKj1xKf0w6n4xaL/t631w6f3xafzw6f5xKb0w6f1w6f1xqj1w6b/v7/1xKd5D16zAAAAFHRSTlMAs16Nkvzy1VkQB8m9QCu3qkzdBDNzh4QAAADfSURBVGje7dpJEoMwDERReTZzBt3/rAmCJDZZCQpW/TZc4FcZS6Z/o0sxJjcSgJa+odYHFsG3BKCgauh5d7ebu7c9f/UoDnaoG1q6etJG441IXPAEoOa5kIzwzS+1Iefh01vPpYD/OFAbA5f6tbilM6Im2zc3GfHgiiMAJceVhxGTs2+5ocHOps6IyJVEAEqJK9GIbrKzgbJ8uzW4wJVIAEqRK2ENrrOzjODg0uBwpMKlRyouDSCuujRgLAIK6rFI2IxFMPiF1dmDX6y2oHD6agvLezhqV0N4ngRahxp6AeqRIp62aEKdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip-desc-bianzu@2x.png
// module id = PJR+
// module chunks = 1